import { FC, ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';

import {
  LockedAccount,
  NoticeConfirmationEmail,
  NoticeCandidateEmail,
} from '@/components';
import { EmailStatusEnum } from '@/api';
import { AgreementModal } from '../_modals/AgreementModal/AgreementModal';

interface RequireAuthProps {
  children: ReactNode;
  redirectTo?: string;
}

const RequireAuth: FC<RequireAuthProps> = (props) => {
  const { children, redirectTo = '/signin' } = props;

  const [searchParams] = useSearchParams();

  const isAuth = useAppSelector(userSelectors.getAuth);
  const isUserLocked = useAppSelector(userSelectors.checkIfUserLocked);
  const termsConfirmRequired = useAppSelector(
    userSelectors.checkIfTermsConfirmRequired,
  );
  const isEmailConfirmed = useAppSelector(userSelectors.checkIfEmailConfirmed);

  const emailCandidate = useAppSelector(userSelectors.checkIfEmailCandidate);
  const { data } = useAppSelector(userSelectors.getUserSlice);

  if (!isAuth) {
    const strSearchParams = searchParams.toString();
    let theReidrectUrl = redirectTo;
    if (strSearchParams.length > 0) {
      theReidrectUrl += `?${strSearchParams}`;
    }
    return <Navigate to={theReidrectUrl} />;
  }

  if (isUserLocked) {
    return <LockedAccount />;
  }

  return (
    <>
      {data && (
        <>
          {!isEmailConfirmed &&
            data.emailStatus !== EmailStatusEnum.CHANGE_REQUESTED && (
              <NoticeConfirmationEmail />
            )}
          {!!emailCandidate && (
            <NoticeCandidateEmail
              email={data.emailAddress}
              candidate={data.emailChangeCandidate}
            />
          )}
        </>
      )}
      {children}
      <AgreementModal isOpen={termsConfirmRequired} />
    </>
  );
};

export default RequireAuth;
